import { useEffect, useState } from "react";
import { obtenerUsuariosPorSuperior } from "../../../services/tropas";

export function useVendors(superiorId) {
  const [vendors, setVendors] = useState([]);
  const [loadingVendors, setLoadingVendors] = useState(false);

  useEffect(() => {
    if (!superiorId) {
      setVendors([]);
      return;
    }
    setLoadingVendors(true);
    async function fetchVendors() {
      try {
        const response = await obtenerUsuariosPorSuperior(superiorId);
        setVendors(response);
      } catch (error) {
        setVendors([]);
      } finally {
        setLoadingVendors(false);
      }
    }
    fetchVendors();
  }, [superiorId]);

  return { vendors, loadingVendors };
} 